import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12 px-6 relative z-30">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <div className="w-8 h-8 bg-white border-2 rounded-sm flex items-center justify-center">
                <img 
                  src="/t.png" 
                  alt="Tare Labs" 
                  className="h-full flex items-center justify-center"
                />
              </div>
              <div className="text-2xl font-bold">
                Tare Labs
              </div>
            </Link>
            <p className="text-gray-400 max-w-md">
              Enterprise-grade technology solutions for logistics and eCommerce companies ready to scale.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/automation" className="text-gray-400 hover:text-white transition-colors">
                  AI Automation
                </Link>
              </li>
              <li>
                <Link to="/services/integration" className="text-gray-400 hover:text-white transition-colors">
                  Integration
                </Link>
              </li>
              <li>
                <Link to="/services/fractional" className="text-gray-400 hover:text-white transition-colors">
                  Fractional and Advisory
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-lg mb-4">Company</h4>
            <ul className="space-y-2">
            <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/#contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400">© 2025 Tare Labs. Delivering Technology.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
